import { showToast } from '@lokalise/louis';

import { showUnexpectedErrorToast } from './components/UnexpectedErrorToast';
import type { ToastLocalStoragePayload } from './types';

export const toastLocalStorage = '@lokalise/show-toast';

const toastMessage = window.localStorage.getItem(toastLocalStorage);

if (toastMessage) {
    const payload = JSON.parse(toastMessage) as ToastLocalStoragePayload;

    showToast(payload);

    window.localStorage.removeItem(toastLocalStorage);
}

export const scheduleToast = (details: ToastLocalStoragePayload) => {
    window.localStorage.setItem(toastLocalStorage, JSON.stringify(details));
};

export { showUnexpectedErrorToast };

export type { ToastEvent, ToastUpdateEvent } from './types';
